import React from 'react';
import { Box, Stack, Typography, Button } from '@mui/material';
import { EditCenterDialog } from '../dialogs';

// Inline spinner component
function InlineSpinner() {
  return <span style={{ display: 'inline-flex', alignItems: 'center', height: 20 }}>
    <svg width="20" height="20" viewBox="0 0 50 50">
      <circle cx="25" cy="25" r="20" fill="none" stroke="#1976d2" strokeWidth="5" strokeDasharray="31.4 31.4" strokeLinecap="round">
        <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
      </circle>
    </svg>
  </span>;
}

const HEADER_STYLES = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: 3,
  borderBottom: '2px solid #3b82f6',
  backgroundColor: '#ffffff',
};

const SAVE_BUTTON_STYLES = {
  minWidth: 120,
  height: 40,
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: '0 2px 8px rgba(59, 130, 246, 0.3)',
  '&:hover': {
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
  }
};

interface CenterHeaderProps {
  form: any; // This should match the full center form structure from CenterDetail
  isUpdating: boolean;
  success: boolean;
  onSave: () => void;
  onCenterUpdate: (updated: any) => void;
}

export const CenterHeader: React.FC<CenterHeaderProps> = ({
  form,
  isUpdating,
  success,
  onSave,
  onCenterUpdate
}) => {
  return (
    <>
      {/* Header Section */}
      <Box sx={HEADER_STYLES}>
        <Stack spacing={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h5" sx={{ fontWeight: 600, color: '#1e293b' }}>
              {form.code} - {form.shortName || form.name}
            </Typography>
            <EditCenterDialog center={form} onSave={onCenterUpdate} />
          </Stack>
          <Stack spacing={1}>
            <Typography variant="body1" sx={{ color: '#64748b' }}>
              {form.address.address1}{form.address.address2 ? `, ${form.address.address2}` : ""}
            </Typography>
            <Typography variant="body1" sx={{ color: '#64748b' }}>
              {form.address.city}, {form.address.state} {form.address.zip}
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" spacing={2}>
          <Button 
            variant="outlined" 
            onClick={() => window.history.back()}
            sx={{ 
              minWidth: 120, 
              height: 40, 
              textTransform: 'none',
              fontWeight: 500 
            }}
          >
            Go Back
          </Button>
          <Button 
            variant="contained" 
            onClick={onSave} 
            disabled={isUpdating}
            sx={SAVE_BUTTON_STYLES}
          >
            {isUpdating ? <InlineSpinner /> : 'Save Changes'}
          </Button>
        </Stack>
      </Box>

      {success && (
        <Box sx={{ px: 3, py: 2, backgroundColor: '#f0f9ff', borderBottom: '1px solid #e2e8f0' }}>
          <Typography color="success.main" align="center" sx={{ fontWeight: 500 }}>
            Center updated successfully!
          </Typography>
        </Box>
      )}
    </>
  );
};